import React from "react"

export default ({ children, id, className }) => (
    <div className={`item-details-columns ${className || ""}`} id={id}>
        {children}
    </div>
)
